import D2C_ServiceData from './Data'

class D2C_ServiceMemcached extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = true
  static order = 26
  static typeName = 'memcached'
  static typeTitle = 'Memcached'
  static color = '#666655'
  static methods = {
    ...D2C_ServiceData.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceData.fields,
    configs: {
      ...D2C_ServiceData.fields.configs,
      default: [
        {name: 'memcached.conf', text: require('raw-loader!@/assets/configs/memcached-memcached.conf').default, custom: false},
      ],
      variables: [...D2C_ServiceData.fields.configs.variables, '$memcachedAuth'],
    },
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'memcached',
    },
    password: {
      default: '',
      label: 'Superuser password',
      path: 'password',
      required: false,
      width: 9,
      validate(value) {
        if (value && value.length < 6) {
          return 'Minimum length is 6 symbols'
        }
        return null
      },
      creating: {},
      importing: {},
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 11211},
      ],
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: '1.6',
      enum: ['1.4', '1.5', '1.6'],
    },
  }
}

export default D2C_ServiceMemcached
